import request from '../../../shared/request'

export function getJobSiteMaterialRequests(job_id) {
  return request(`/job/job_site_material_requests/${job_id}/`)
}

export function createJobSiteMaterialRequest(payload) {
  return request(`/job/job_site_material_requests/${payload.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateMaterialRequest(payload) {
  return request(`/job/job_site_material_requests/${payload.material_request_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteMaterialRequest(payload) {
  return request(`/job/job_site_material_requests/${payload.material_request_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getMaterialItems(materialRequestId) {
  return request(`/job/job_site_material_requests/${materialRequestId}/items`)
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_material_requests/${payload.materialRequestId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(materialRequestId) {
  return request(`/job/job_site_material_requests/${materialRequestId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_material_requests/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_site_material_requests/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteMaterialRequests.js